







import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator'
import { Message } from 'element-ui'
import SearchPaginationTable from '@/components/search-pagination-table.vue'
import http from '../unite/http'
@Component({
  components: { SearchPaginationTable }
})
export default class DialogTable extends Vue {
  @Prop() form: any
  dialogVisible: boolean = true
  numWidth: string = '1300'
  pageData: any = {
    url: '',
    isSearch: false, // 是否需要搜索框
    isPagination: true, // 是否后端分页
    isBtn: false, // 是否需要头部操作按钮
    info: {}, // 传后端数据
    searchData: [],
    btnData: [],
    tableData: {
      stripe: true,
      border: true,
      expandShow: false,
      optionShow: false,
      header: [],
      expand: [],
      option: []
    } // table
  }
  created() {
    this.pageData.url = this.form.url
    this.pageData.info = this.form.info
    this.pageData.tableData.header = this.form.header
  }
  // 取消
  cancel() {
    this.$emit('refesh', false)
  }
}
